import { RadioGroup } from '@headlessui/react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import { useQuotation } from '../context'
import { MreAcheelPackage } from '../../generated/graphql'

import { PricingMRPPackageCard } from './PricingMRPPackageCard'

const packages: Record<MreAcheelPackage, { name: string; description: JSX.Element }> = {
  [MreAcheelPackage.Basic]: {
    name: 'Basic',
    description: (
      <p>
        L'essentiel pour protéger votre activité, avec les garanties indispensables pour couvrir
        votre responsabilité civile professionnelle et vos biens.
      </p>
    ),
  },
  [MreAcheelPackage.Comfort]: {
    name: 'Confort',
    description: (
      <p>
        Une protection renforcée qui complète la formule Basic avec des garanties supplémentaires :
        le tous risques informatiques et le choc de véhicule terrestre.
      </p>
    ),
  },
  [MreAcheelPackage.Premium]: {
    name: 'Premium',
    description: (
      <p>
        Une protection optimale qui reprend les garanties précédentes et qui inclut la perte
        d'exploitation : en cas de sinistre couvert entraînant une interruption de votre activité,
        elle compense la perte de revenus le temps de reprendre votre activité.
      </p>
    ),
  },
}

export const PricingMREAcheelPackageSection = React.forwardRef<HTMLElement, { className?: string }>(
  ({ className }, ref) => {
    const { quotation, updateQuotation } = useQuotation()

    const details = quotation.details.mreAcheel

    return (
      <section className={twMerge(className)} id="package" ref={ref}>
        <RadioGroup
          value={details?.packageOptionMAcheel ?? undefined}
          onChange={(value: MreAcheelPackage) =>
            updateQuotation({
              details: {
                mreAcheel: {
                  packageOptionMAcheel: value,
                  // deductibleAmount: frequenceChange(value),
                },
              },
            })
          }
        >
          <div className="space-y-3">
            <h2 className="text-lg font-bold md:text-xl">
              Votre formule pour modifier votre protection
            </h2>
            {[
              Object.values(MreAcheelPackage).map((value) => (
                <RadioGroup.Option value={value} key={value}>
                  {({ checked }) => (
                    <PricingMRPPackageCard
                      key={value}
                      title={packages[value].name}
                      description={packages[value].description}
                      checked={checked}
                    />
                  )}
                </RadioGroup.Option>
              )),
            ]}
          </div>
        </RadioGroup>
      </section>
    )
  }
)
